import { verify } from "jsonwebtoken";

// starting depth is 0, depth 1 means object with a property that is an object and we re looking for a property inside that 2nd object
export const findPropWithDepth = (depth, item, props) => {

  if(depth === 0) return item[props[0]]
  else if (depth === 1) return item[props[0]][props[1]]
  else if (depth === 2) return item[props[0]][props[1]][props[2]]
  else if (depth === 3) return item[props[0]][props[1]][props[2]][props[3]]
  else if (depth === 4) return item[props[0]][props[1]][props[2]][props[3]][props[4]]
  else if (depth === 5) return item[props[0]][props[1]][props[2]][props[3]][props[4]][props[5]]
  else throw Error('Unsupported Depth');

}

export const verifyAuthToken = (token) => {
	const secret = process.env.REACT_APP_JWT_SECRET
	try {
			verify(token, secret);
			return true;
	} catch(e) {
		 return false;
	}
}

export const deleteCookie = name => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};


export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
